import React, { PropTypes } from 'react';

let LoadingMessage = React.createClass({
	propTypes: {
		message: PropTypes.string.isRequired
	},

	render: function() {
		return (
			<h4 className="heading-processing">
				<i className="glyphicon glyphicon-star glyphicon-spin" />
				{' '}{ this.props.message }
			</h4>
		);
	}
});

module.exports = LoadingMessage;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/LoadingMessage.jsx